import { getSucursal } from "./helpers";

export const apiUrl = (path, useSucursal = true) => {
    const sucursal = useSucursal ? "s/" + getSucursal() + "/" : "";
    return `https://apirecolector.sae.com.do/api/v1/${sucursal}${path}`;
}
